import React from "react";
import { Tooltip } from "@mui/material";
import palette from "../../../../utilities/palette";

const MAX_DISPLAYED_ERRORS = 3;

export type FormatErrorDisplay = {
  displayedErrors: string[];
  remaining: number;
  remainingErrors: string[];
};

export const buildFormatErrorDisplay = (errors: string[]): FormatErrorDisplay => {
  const displayedErrors = errors.slice(0, MAX_DISPLAYED_ERRORS);
  const remainingErrors = errors.slice(MAX_DISPLAYED_ERRORS);
  const remaining = remainingErrors.length;
  return { displayedErrors, remaining, remainingErrors };
};

type FormatErrorDisplayProps = {
  formatErrorDisplay: FormatErrorDisplay;
};

const FormatErrorDisplayBlock = ({ formatErrorDisplay }: FormatErrorDisplayProps) => {
  return (
    <div style={{ color: palette.stepper.error, marginLeft: "20px", marginBottom: "10px" }}>
      <div style={{ fontWeight: 600 }}>Format Validation failed:</div>
      <ul style={{ margin: "6px 0 0 32px", padding: 0 }}>
        {formatErrorDisplay.displayedErrors.map((line, index) => (
          <li key={`${line}-${index}`} style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
            {line}
          </li>
        ))}
      </ul>
      {formatErrorDisplay.remaining > 0 && (
        <Tooltip
          title={
            <div>
              <div style={{ fontWeight: 600, marginBottom: "4px" }}>Additional format issues:</div>
              <ul style={{ margin: 0, paddingLeft: "32px" }}>
                {formatErrorDisplay.remainingErrors.map((line, index) => (
                  <li key={`${line}-remaining-${index}`} style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                    {line}
                  </li>
                ))}
              </ul>
            </div>
          }
          arrow
          placement="top-start"
        >
          <button
            type="button"
            aria-label={`Show ${formatErrorDisplay.remaining} additional format issue${formatErrorDisplay.remaining > 1 ? "s" : ""}`}
            style={{
              textDecoration: "underline",
              cursor: "help",
              paddingLeft: "32px",
              background: "none",
              border: "none",
              color: "inherit",
              font: "inherit",
            }}
          >
            ...and {formatErrorDisplay.remaining} other format issue{formatErrorDisplay.remaining > 1 ? "s" : ""}.
          </button>
        </Tooltip>
      )}
    </div>
  );
};

export default FormatErrorDisplayBlock;
